import { Deal, DealStage, DEAL_STAGES, OPEN_STAGES } from "@/types/deal";

export const sumValue = (deals: Deal[]) =>
  deals.reduce((total, d) => total + d.value, 0);

export const dealsByStage = (deals: Deal[]): Record<DealStage, Deal[]> => {
  const grouped = {} as Record<DealStage, Deal[]>;
  for (const stage of DEAL_STAGES) grouped[stage] = [];
  for (const deal of deals) grouped[deal.stage].push(deal);
  return grouped;
};

export const openDeals = (deals: Deal[]) =>
  deals.filter((d) => OPEN_STAGES.includes(d.stage));

export const wonDeals = (deals: Deal[]) => deals.filter((d) => d.stage === "won");
